import { defineFcm } from '../shared/factory';

export const FCM_TOPIC_CLASSIFIER_SERVICE_AUTO_TRIGGER_ENABLED = defineFcm(
	'topic_classifier_service_auto_trigger_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig();
